export const STORE_STUFF = 'STORE_STUFF';
export type STORE_STUFF = {
    stuff: string;
};

export type STUFF = {
    stuff: string;
};